"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reloadMiddleware = void 0;
/* eslint-disable import/prefer-default-export */
// This middleware loads the reload plugin with config
var reloadMiddleware = exports.reloadMiddleware = function reloadMiddleware(player) {
  var _player$options = player.options(),
    reloadConf = _player$options.reloadConf;
  if (reloadConf) {
    player.reloadSourceOnError(reloadConf);
  }
  return true;
};
reloadMiddleware.VERSION = '1.0.0';